import { render, staticRenderFns } from "./Myerrtexts.vue?vue&type=template&id=21015e2b&scoped=true"
import script from "./Myerrtexts.vue?vue&type=script&lang=js"
export * from "./Myerrtexts.vue?vue&type=script&lang=js"
import style0 from "./Myerrtexts.vue?vue&type=style&index=0&id=21015e2b&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21015e2b",
  null
  
)

export default component.exports